export default {
  tab: {
    contribution: 'Tỷ Trọng',
    foreign: 'Nước ngoài',
    proprietary: 'Tự Doanh',
  },
  tooltipMatched: 'Gía Khớp: ',
  noData: 'Không có dữ liệu',
  noDataSell: 'Bán',
  noDataBuy: 'Mua',
  tooltipDate: 'Dữ liệu được tính toàn từ ngày %{from} đến %{to}',
  tooltipToday: 'Dữ liệu được tính tại %{from}',
};
